import { AxiosAuth } from "../axios";
import { ApiSchemaCountryList } from "../../models/api/apiCountryList";
import { AppRoutesApi } from "../../config/appRoutes";
import { ApiResponseContainer } from '../../models/api/apiResponseContainer';

const getCountryList = async () => {
  const res = await AxiosAuth.get<ApiResponseContainer<ApiSchemaCountryList[]>>(
    AppRoutesApi.GetAllCountries.GetAllCountriesList
  );
  return res.data;
};

export const ApiCountryList = { getCountryList };
